// Joins a game and keeps the seat's private key for that code and nickname, so a reload gets the seat back.
import axios from 'axios';

const slot = (code, name) => `playerKey:${code}:${name.trim()}`;

// Storage can throw (private mode, blocked site data); a join must still enter the game.
export const storedKey = (code, name) => {
  try { return localStorage.getItem(slot(code, name)); } catch (e) { return null; }
};

export async function joinGame(code, name) {
  const key = storedKey(code, name);
  const res = await axios.post(`games/${code}/join`, key ? { name, key } : { name });
  try { localStorage.setItem(slot(code, res.data.player.name), res.data.player.key); } catch (e) { /* see above */ }
  return res;
}

export function forgetGame(code, name) {
  try { localStorage.removeItem(slot(code, name)); } catch (e) { /* see above */ }
}
